import React, { useContext } from 'react'
import { Select } from 'antd'
import { t } from 'i18next'
import { post } from '../../Common/api'
import GlobalContext from '../GlobalContext'

export default function EventInChargeSelect ({ event, updateEventData, style = { minWidth: '100%' }, onChange, reduced = false }) {
  const { notificationApi, inCharge } = useContext(GlobalContext)
  let options = []
  if (reduced) {
    options = inCharge ? Object.keys(inCharge.shortened).map((k) => ({ value: k, label: inCharge.shortened[k] })) : []
  } else {
    options = inCharge ? Object.keys(inCharge.name).map((k) => ({ value: k, label: inCharge.name[k] })) : []
  }

  const defaultOnChange = (value, event, updateEventData) => {
    post({
      url: `admin/events/${event.id}/in_charge`,
      params: { in_charge: value },
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (json) => {
        updateEventData({ ...json.event, comments: json.comments })
      }
    })
  }

  onChange = onChange || defaultOnChange

  return (
    <Select value={event?.in_charge} options={options} onChange={(v) => onChange(v, event, updateEventData)} style={style}
      placeholder={t('Admin.EventList.table.nobodyInCharge')} defaultValue={event ? '' : 'vig_1'}/>
  )
}
